"use client";

import { useState, useEffect } from "react";
import { X } from "lucide-react";

import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";
import { cn } from "@/lib/utils";

export function Toaster() {
	const { toasts, dismiss } = useToast();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	const basketToasts = toasts.filter((t) => t.variant === "basket");
	const standardToasts = toasts.filter((t) => t.variant !== "basket");

	if (!mounted) {
		return (
			<ToastProvider>
				<ToastViewport />
			</ToastProvider>
		);
	}

	return (
		<>
			<ToastProvider>
				{standardToasts.map(function ({ id, title, description, action, ...props }) {
					return (
						<Toast key={id} {...props}>
							<div className="grid gap-1">
								{title && <ToastTitle>{title}</ToastTitle>}
								{description && <ToastDescription>{description}</ToastDescription>}
							</div>
							{action}
							<ToastClose />
						</Toast>
					);
				})}
				<ToastViewport />
			</ToastProvider>

			{/* Add-to-basket only — bottom centre, outside the left toast viewport */}
			<div
				aria-live="polite"
				className="pointer-events-none fixed bottom-6 left-1/2 z-[100] flex w-full max-w-md -translate-x-1/2 flex-col items-center gap-2 px-4"
			>
				{basketToasts.map(({ id, description, open, onOpenChange }) =>
					open ? (
						<div
							key={id}
							role="status"
							className={cn(
								"glassmorphism-card pointer-events-auto w-full overflow-hidden rounded-2xl border border-[color:var(--glass-border)] text-foreground shadow-[var(--glass-shadow)]",
								"animate-in slide-in-from-bottom-full fade-in-80",
							)}
						>
						<div className="relative p-4">
							{description}
							<button
								type="button"
								aria-label="Dismiss"
								className="absolute right-2 top-2 z-[2] rounded-md p-1 text-brand-primary transition-opacity hover:text-brand-secondary hover:opacity-100"
								onClick={() => {
									onOpenChange?.(false);
									dismiss(id);
								}}
							>
								<X className="size-4" strokeWidth={2.25} />
							</button>
						</div>
					</div>
					) : null,
				)}
			</div>
		</>
	);
}
